import {
  defaultCheckboxColumnDefinition,
  defaultColumnDefinitionWithFilter,
} from '../../shared/columnDefinitions';

import {
  DeploymentClientCheckboxCellRenderer,
  DeploymentClientHeaderCheckbox,
} from './deploymentClientCheckbox.component';

export const CLIENT_CHECKBOX_COLUMN_ID = 'clientCheckboxColumn';

const getColumnDefinitions = ({
  hasPermissionToAuthorize,
  selectableClientIds,
  selectedClientIds,
  onToggleClient,
  onToggleAll,
}) => {
  const clientNameColumn = {
    ...defaultColumnDefinitionWithFilter,
    flex: 1,
    resizable: false,
    headerName: 'Client',
    field: 'name',
  };

  if (!hasPermissionToAuthorize) {
    return [clientNameColumn];
  }

  return [
    {
      ...defaultCheckboxColumnDefinition,
      colId: CLIENT_CHECKBOX_COLUMN_ID,
      headerName: '',
      width: 40,
      maxWidth: 40,
      minWidth: 40,
      resizable: false,
      sortable: false,
      filter: false,
      suppressHeaderMenuButton: true,
      headerComponent: DeploymentClientHeaderCheckbox,
      headerComponentParams: {
        selectableClientIds,
        selectedClientIds,
        onToggleAll,
      },
      cellRenderer: DeploymentClientCheckboxCellRenderer,
      cellRendererParams: { onToggleClient },
      cellStyle: {
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    clientNameColumn,
  ];
};

export default getColumnDefinitions;
